import querystring from 'qs';
import { Location } from 'react-router-dom';

import { CommonQueryParams, getCommonQueryParams } from 'utils/paramConverters';

import { PassType } from 'modules/eurail/utils/types';

export type EurailQueryParams = {
  fareClass: string;
  to?: string;
  adult: number;
  youth: number;
  child: number;
  senior: number;
  pass: PassType;
  currency?: string;
};

/**
 * Returns the query parameters for the Eurail Search Input page.
 *
 * @param location - location descriptor
 *
 * @returns EurailQueryParams
 */
export const getEurailSearchInputPageQueryParams = (
  location: Location = window.location as any,
): EurailQueryParams => {
  const queryParams: any = querystring.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  return {
    fareClass: queryParams.fareClass,
    to: queryParams.to,
    adult: Number(queryParams.adult),
    youth: Number(queryParams.youth),
    child: Number(queryParams.child),
    senior: Number(queryParams.senior),
    pass: queryParams.pass,
  };
};

export const getStopoverLandingPageQueryParams = (
  location: Location = window.location as any,
): { sk?: string } => {
  const queryParams: any = querystring.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  return {
    sk: queryParams.sk,
  };
};

/**
 * Returns the query parameters for the Eurail Search Results page.
 *
 * @param location - location descriptor
 *
 * @returns EurailSearchResultsPageQueryParams
 */
export const getEurailSearchResultsPageQueryParams = (
  location: Location = window.location as any,
): EurailQueryParams => {
  return getEurailSearchInputPageQueryParams(location);
};

export type EurailTravellerInputPageQueryParams = CommonQueryParams & {
  searchResultID: string;
};

/**
 * Returns the query parameters for the Eurail Traveller Information page.
 *
 * @param location - location descriptor
 */
export const getEurailTravellerInputPageQueryParams = (
  location: Location = window.location as any,
): EurailTravellerInputPageQueryParams => {
  const queryParams: any = querystring.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const commonQueryParams = getCommonQueryParams(location);
  const eurailTravellerInputPageParams = {
    searchResultID: queryParams.searchResultID,
  };

  return {
    ...commonQueryParams,
    ...eurailTravellerInputPageParams,
  };
};

export type EurailPaymentInputPageQueryParams = CommonQueryParams & {
  searchResultID: string;
  bookingIntentId: string;
  shoppingCartId?: string;
  userId?: string;
};

/**
 * Returns the query parameters for the Eurail Payment Input page.
 *
 * @param location - location descriptor
 */
export const getEurailPaymentInputPageQueryParams = (
  location: Location = window.location as any,
): EurailPaymentInputPageQueryParams => {
  const queryParams: any = querystring.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const commonQueryParams = getCommonQueryParams(location);
  const eurailPaymentInputPageParams = {
    searchResultID: queryParams.searchResultID,
    bookingIntentId: queryParams.bookingIntentId,
    shoppingCartId: queryParams.shoppingCartId,
    userId: queryParams.userId,
  };

  return {
    ...commonQueryParams,
    ...eurailPaymentInputPageParams,
  };
};
